import Icon from "../../../components/common/Icon";
import { Link } from "react-router-dom";
import Header from "../../../components/common/Header";
import { useEffect, useRef, useState } from "react";
import useData from "../../../hooks/useData";
import { deleteSingleImageFromDb, getDefaultImageLibrary, setImageEnable } from "../../../api/admin/imageReq";
import useAuth from "../../../hooks/useAuth";

export default function Images({ tab }) {
    const { imageLib, setImageLib, setSingleImage,
    } = useData();
    const { auth } = useAuth();
    const token = auth?.token;
    const imageFolder = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    let deceasedImageLib = imageLib?.filter((image) => (image?.category == 1));
    let announceImageLib = imageLib?.filter((image) => (image?.category == 2));
    let symbolImageLib = imageLib?.filter((image) => (image?.category == 3));

    const [combinedDeceasedImageList, setCombinedDeceasedImageList] = useState([]);


    const apiImageLib = async () => {
        const response = await getDefaultImageLibrary(token)
        setImageLib(response)
    }

    useEffect(() => {
        apiImageLib()
    }, []);

    useEffect(() => {
        if (deceasedImageLib && deceasedImageLib.length > 0) {
            const combined = [];

            const agencies = [...new Set(deceasedImageLib.map(img => img?.agencyId).filter(Boolean))];

            deceasedImageLib.forEach(image => {
                combined.push({
                    ...image,
                    path: `${imageFolder}/img/deceased_library/${image?.url}`,
                    source: 'root',
                    uniqueKey: `root-${image.id}`
                });

                agencies.forEach(agencyId => {
                    combined.push({
                        ...image,
                        path: `${imageFolder}/img/deceased_library/${agencyId}/${image?.url}`,
                        source: 'agency',
                        displayAgencyId: agencyId,
                        uniqueKey: `agency-${agencyId}-${image.id}`
                    });
                });
            });

            setCombinedDeceasedImageList(combined);
        }
    }, [deceasedImageLib, imageFolder]);

    const handleDeleteImage = async (id, category) => {
        let body = {
            imageId: id,
            category: category,
        }
        await deleteSingleImageFromDb(token, body)
        apiImageLib()
    }

    const handleImageEnable = async (imageId, newEnabled) => {
        if (!auth.roles.includes("ROLE_BACKEND")) {
            alert("Vous n'avez pas les droits pour modifier la visibilité d'une image.");
        } else {
            let body = {
                "imageEnabled": newEnabled,
                "imageId": imageId,
            }
            alert(newEnabled ? "Vous venez d'activer cette image." : "Vous venez de désactiver cette image.");
            await setImageEnable(token, body)
            apiImageLib()
        }
    }

    const sources = "fa fa-image"
    const tabSource = "fa fa-bars"
    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Images"
                tab="deceased"
                slug="/admin/accueil"
            />
            <div>
                <nav className="tabs-menu">
                    <ul>
                        <li className={tab === "deceased" && "active"}><Link to="/admin/images/defunts">Images défunts</Link></li>
                        <li className={tab === "img-announce" && "active"}><Link to="/admin/images/faire-part">Images faire-part</Link></li>
                        <li className={tab === "symbols" && "active"}><Link to="/admin/images/symboles">Symboles faire-part</Link></li>
                    </ul>
                </nav>
                <div className="content-container">
                    <div className="cms-button dashboard-add-button">
                        <Link onClick={() => setSingleImage([])} to="/admin/images/0/voir"><button><i className="fa fa-plus"></i><span>Ajouter</span></button></Link>
                    </div>
                    {(tab === "deceased") &&
                        <div className="dashboard images">
                            <Icon source={sources} color="blue" span="Gestion des images par défaut d'un défunt" />
                            {combinedDeceasedImageList?.length > 0 ?
                                <>
                                    <div className="flex"><p>{combinedDeceasedImageList?.length} image(s) dans cette bibliothèque.</p></div>
                                    <div className="images-div">
                                        {combinedDeceasedImageList?.map((imageDeceased) => (
                                            <div key={imageDeceased.uniqueKey} className={`image ${!imageDeceased?.enabled ? 'disabled' : ''}`}>
                                                <div className="overlay">
                                                    <div className="column">
                                                        <Link to={`/admin/images/${imageDeceased?.id}/voir`}>
                                                            <div className="flex">
                                                                <i className="fa fa-pen-to-square"></i>
                                                                <span>Modifier</span>
                                                            </div>
                                                        </Link>
                                                        <div className="flex">
                                                            <i className="fa fa-trash" onClick={(e) => handleDeleteImage(imageDeceased?.id, "1")}></i>
                                                            <i
                                                                id={imageDeceased?.id}
                                                                className={imageDeceased?.enabled ? "fa fa-eye-slash" : "fa fa-eye"}
                                                                onClick={() => handleImageEnable(imageDeceased?.id, !imageDeceased?.enabled)}
                                                                title={imageDeceased?.enabled ? "Image visible - Cliquer pour masquer" : "Image masquée - Cliquer pour rendre visible"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <img src={imageDeceased.path}
                                                     className='portrait'
                                                     alt="Portrait par défaut"
                                                     onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.style.display = 'none'; }}
                                                />
                                                {imageDeceased.displayAgencyId && (
                                                    <div className="image-agency-badge">
                                                        Agence {imageDeceased.displayAgencyId}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </>
                                :
                                <div className="flex">
                                    <p>Pas d'image dans cette bibliothèque.</p>
                                </div>
                            }
                        </div>
                    }
                    {(tab === "img-announce") &&
                        <div className="dashboard images">
                            <Icon source={sources} color="blue" span="Gestion des images par défaut d'un faire-part" />
                            {announceImageLib?.length > 0 ?
                                <>
                                    <div className="flex">
                                        <p>{announceImageLib?.length} image(s) dans cette bibliothèque.</p>
                                    </div>
                                    <div className="images-div">
                                        {announceImageLib?.map((imageAnnounce, index) => (
                                            <div key={index} className={`image ${!imageAnnounce?.enabled ? 'disabled' : ''}`}>
                                                <div className="overlay">
                                                    <div className="column">
                                                        <Link to={`/admin/images/${imageAnnounce?.id}/voir`}>
                                                            <div className="flex">
                                                                <i className="fa fa-pen-to-square"></i>
                                                                <span>Modifier</span>
                                                            </div>
                                                        </Link>
                                                        <div className="flex">
                                                            <i className="fa fa-trash"
                                                               onClick={(e) => handleDeleteImage(imageAnnounce?.id, "2")}></i>
                                                            <i
                                                                id={imageAnnounce?.id}
                                                                className={imageAnnounce?.enabled ? "fa fa-eye-slash" : "fa fa-eye"}
                                                                onClick={() => handleImageEnable(imageAnnounce?.id, !imageAnnounce?.enabled)}
                                                                title={imageAnnounce?.enabled ? "Image visible - Cliquer pour masquer" : "Image masquée - Cliquer pour rendre visible"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <img
                                                    className='portrait'
                                                    src={`${imageFolder}/img/fpr/symboles_miniature/${imageAnnounce?.url}`}
                                                    alt="Photo de faire-part"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </>
                                :
                                <div className="flex">
                                    <p>Pas d'image dans cette bibliothèque.</p>
                                </div>
                            }
                        </div>
                    }
                    {(tab === "symbols") &&
                        <div className="dashboard images">
                            <Icon source={sources} color="blue" span="Gestion des symboles par défaut d'un faire-part" />
                            {symbolImageLib?.length > 0 ?
                                <>
                                    <div className="flex">
                                        <p>{symbolImageLib?.length} image(s) dans cette bibliothèque.</p>
                                    </div>
                                    <div className="images-div">
                                        {symbolImageLib?.map((imageAnnounce, index) => (
                                            <div key={index} className={`image ${!imageAnnounce?.enabled ? 'disabled' : ''}`}>
                                                <div className="overlay">
                                                    <div className="column">
                                                        <Link to={`/admin/images/${imageAnnounce?.id}/voir`}>
                                                            <div className="flex">
                                                                <i className="fa fa-pen-to-square"></i>
                                                                <span>Modifier</span>
                                                            </div>
                                                        </Link>
                                                        <div className="flex">
                                                            <i className="fa fa-trash"
                                                               onClick={(e) => handleDeleteImage(imageAnnounce?.id, "3")}></i>
                                                            <i
                                                                id={imageAnnounce?.id}
                                                                className={imageAnnounce?.enabled ? "fa fa-eye-slash" : "fa fa-eye"}
                                                                onClick={() => handleImageEnable(imageAnnounce?.id, !imageAnnounce?.enabled)}
                                                                title={imageAnnounce?.enabled ? "Image visible - Cliquer pour masquer" : "Image masquée - Cliquer pour rendre visible"}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <img
                                                    className='portrait'
                                                    src={`${imageFolder}/img/fpr/symboles-miniature/${imageAnnounce?.url}`}
                                                    alt="Photo de faire-part"
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </>
                                :
                                <div className="flex">
                                    <p>Pas d'image dans cette bibliothèque.</p>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        </main>
    )
}
